import { Locale } from '@ps-smart-cp/ppfw-client';
import { enumToName, rawValueToEnum } from '../utils';

enum AppxTgtType {
  unspecified = '00',
  appxSixteenOneTgtAsset = '10',
  appxSixteenTwoTgtAsset = '20',
  appxSixteenUpperTgtAsset = '61',
  appxSixteenLowerTgtAsset = '62',
}

const nameConfig = {
  unspecified: new Map([
    [Locale.ja, '指定なし'],
    [Locale.en, 'Unspecified'],
  ]),
  appxSixteenOneTgtAsset: new Map([
    [Locale.ja, '別表十六(一)対象資産'],
    [Locale.en, 'Appendix Sixteen One Target Asset'],
  ]),
  appxSixteenTwoTgtAsset: new Map([
    [Locale.ja, '別表十六(二)対象資産'],
    [Locale.en, 'Appendix Sixteen Two Target Asset'],
  ]),
  appxSixteenUpperTgtAsset: new Map([
    [Locale.ja, '別表十六(六)・上段対象資産'],
    [Locale.en, 'Appendix Sixteen Upper Target Asset'],
  ]),
  appxSixteenLowerTgtAsset: new Map([
    [Locale.ja, '別表十六(六)・下段対象資産'],
    [Locale.en, 'Appendix Sixteen Lower Target Asset'],
  ]),
};

const toEnum = rawValueToEnum(AppxTgtType, '');
const toDisplay = enumToName(AppxTgtType, nameConfig);
const toDisplayWithPrefix = enumToName(AppxTgtType, nameConfig, { prefix: true });

export const appxTgtType = {
  enum: AppxTgtType,
  nameConfig,
  toEnum,
  toDisplay,
  toDisplayWithPrefix,
};
export type { AppxTgtType };
